import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { Formik, Form, FastField } from "formik";
import * as Yup from "yup";
import TextField from "@mui/material/TextField";
import DropdownSelector from "../../../atoms/Common/DropdownSelector.tsx";
import { addClientWarehouse, getClientList } from "../../../api/client";
import { useSnack } from "../../../services/SnakbarProvider";
import { handleError } from "../../../services/errorHandler";
import ClientWarehouseAddressFields from "./addressFields";

const validationSchema = Yup.object().shape({
  clientId: Yup.number().integer().required("El cliente es obligatorio"),
  name: Yup.string().required("El nombre es obligatorio"),
  street: Yup.string().required("La calle es obligatoria"),
  outNum: Yup.string().required("El número exterior es obligatorio"),
  colony: Yup.string().required("La colonia es obligatoria"),
  municipality: Yup.string().required("El municipio es obligatorio"),
  country: Yup.string().required("El país es obligatorio"),
  state: Yup.string().required("El estado es obligatorio"),
  cp: Yup.string().required("El código postal es obligatorio"),
});

export default function CreateClientWarehouseForm({ companyId, onSubmit }) {
  const { openSnack } = useSnack();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    clientId: "",
    name: "",
    street: "",
    outNum: "",
    innNum: "",
    colony: "",
    municipality: "",
    country: "",
    state: "",
    cp: "",
  };

  const fetchClients = async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const res = await getClientList({
        companyId,
        pageNumber: 1,
        pageSize: 1000,
      });
      setClients(res.data);
    } catch (e) {
      openSnack(handleError(e), "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, [companyId]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        ...values,
        companyId,
      };
      await addClientWarehouse(payload);
      openSnack("Almacén de cliente creado con éxito", "success");
      onSubmit();
    } catch (e) {
      openSnack(handleError(e), "error");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 1 }}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FastField
                  name="clientId"
                  label="Cliente"
                  as={DropdownSelector}
                  parentOptions={clients}
                  optionLabel={["code", "name"]}
                  optionSeparator=" | "
                />
              </Grid>
              <Grid item xs={12}>
                <FastField
                  fullWidth
                  name="name"
                  label="Nombre del almacén"
                  as={TextField}
                />
              </Grid>
              <ClientWarehouseAddressFields />
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                >
                  Crear
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
